export default __webpack_public_path__ + "static/media/slide4.75713be5.jpg";